// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebar_container__3lh2L{\n    /*padding-top: 5% !important;*/\n}\n.sidebar_header__6r_-z{\n    display: block;\n    background: var(--primary-color);\n    padding: 8px;\n    width: 100%;\n    text-align: left;\n}\n", "",{"version":3,"sources":["webpack://src/components/sidebar/sidebar.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[".container{\n    /*padding-top: 5% !important;*/\n}\n.header{\n    display: block;\n    background: var(--primary-color);\n    padding: 8px;\n    width: 100%;\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "sidebar_container__3lh2L",
	"header": "sidebar_header__6r_-z"
};
export default ___CSS_LOADER_EXPORT___;
